<template>
  <v-row class="supplier-detail custom-border-top pt-4">
    <v-col md="8" sm="12" class="pt-0">
      <div class="new-white-box-overview-main nav">
        <div class="col-md-5 supplier-image text-center">
          <v-skeleton-loader
            class="custom-skeleton"
            v-if="pageLoading"
            type="image"
          >
          </v-skeleton-loader>
          <template v-else>
            <v-img
              :lazy-src="$defaultProfileImage"
              :src="getProfileImage"
              aspect-ratio="1"
              max-height="200"
              max-width="200"
              class="margin-auto custom-grey-border custom-border-radius-50"
              transition="fade-transition"
            >
            </v-img>
            <Status :status="supplierActivated"></Status>
          </template>
        </div>
        <div class="col-md-7 gray-background pt-0">
          <h5 class="font-weight-600 font-size-18 pt-3">
            <v-skeleton-loader
              class="custom-skeleton"
              v-if="pageLoading"
              type="button"
            >
            </v-skeleton-loader>
            <Barcode v-else :barcode="getBarcode"></Barcode>
          </h5>
          <v-skeleton-loader
            class="custom-skeleton"
            v-if="pageLoading"
            type="text@5"
          >
          </v-skeleton-loader>
          <table v-else class="width-100">
            <!-- <tr>
              <td class="pb-2 font-size-18 text-capitalize">Security Code</td>
              <td class="pb-2 font-size-18 font-weight-600 text-capitalize">
                {{ supplier.security_code }}
              </td>
            </tr> -->
            <tr>
              <td class="pb-2 font-size-18 text-capitalize">Name</td>
              <td class="pb-2 font-size-18 font-weight-600 text-capitalize">
                {{ fullname }}
              </td>
            </tr>
            <tr>
              <td class="pb-2 font-size-18 text-capitalize">Company Name</td>
              <td class="pb-2 font-size-18 font-weight-600 text-capitalize">
                <template v-if="supplier.company_name">{{
                  supplier.company_name
                }}</template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No company name</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td class="pb-2 font-size-18 text-capitalize">Display Name</td>
              <td
                class="pb-2 font-size-18 font-weight-600 text-capitalize"
                v-if="supplier && supplier.display_name"
              >
                {{ supplier.display_name }}
              </td>
              <em v-else class="text-muted ml-2"> no display name</em>
            </tr>

            <!-- <tr>
                <td class="pb-2 font-size-18 text-capitalize">Company Email</td>
                <td
                  class="pb-2 font-size-18 font-weight-600"
                  v-if="supplier && supplier.company_email"
                >
                  {{ supplier.company_email }}
                </td>
                <em v-else class="text-muted ml-2"> no company email</em>
              </tr> -->

            <!-- <tr v-for="(detail, index) in supplier.details" :key="index">
            <td class="pb-2 font-size-18 text-capitalize">
              {{ getDetailType(detail.type) }}
            </td>
            <td
              class="pb-2 font-size-18 font-weight-600 text-lowercase width-50px"
            >
              ({{ detail.title }})
            </td>
            <td class="pb-2 pl-2 font-size-18 font-weight-600 text-lowercase">
              {{ detail.value }}
            </td>
          </tr> -->

            <tr>
              <td class="pb-2 font-size-18 text-capitalize">Funding Organisation Email</td>
              <td
                class="pb-2 font-size-18 font-weight-600"
                v-if="supplier && supplier.company_email"
              >
                {{ supplier.company_email }}
              </td>
              <em v-else class="text-muted ml-2"> no funding organisation email</em>
            </tr>

            <tr>
              <td class="pb-2 font-size-18 text-capitalize">
                Funding Organisation Phone Number
              </td>
              <td
                class="pb-2 font-size-18 font-weight-600 text-capitalize"
                v-if="supplier && supplier.company_number"
              >
                {{ supplier.company_number }}
              </td>
              <em v-else class="text-muted ml-2"> no funding organisation phone number</em>
            </tr>

            <tr>
              <td class="pb-2 font-size-18 text-capitalize">Funding Organisation fax</td>
              <td class="pb-2 font-size-18 font-weight-600 text-capitalize">
                <template v-if="supplier.company_fax">
                  {{supplier.company_fax}}
                </template>
                <template v-else>
                  <em class="text-muted font-weight-400">
                    No funding organisation fax
                  </em></template>
              </td>
            </tr>
            <tr>
              <td class="pb-2 font-size-18">UEN</td>
              <td class="pb-2 font-size-18 font-weight-600 text-lowercase">
                <template v-if="supplier.uen">{{ supplier.uen }}</template>
                <template v-else
                  ><em class="text-muted font-weight-400"
                    >No uen</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td class="pb-2 font-size-18 text-capitalize">Website</td>
              <td class="pb-2 font-size-18 font-weight-600 text-lowercase">
                <template v-if="supplier.website">{{
                  supplier.website
                }}</template>
                <template v-else
                  ><em class="text-muted font-weight-400"
                    >No Website</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td class="pb-2 font-size-18 text-capitalize d-flex">
                Funding Organisation Remark
              </td>
              <td class="pb-2 font-size-18 font-weight-600 text-lowercase">
                <template v-if="supplier.supplier_remark">{{
                  supplier.supplier_remark
                }}</template>
                <template v-else
                  ><em class="text-muted font-weight-400"
                    >no funding organisation remark</em
                  ></template
                >
              </td>
            </tr>

            <!-- <tr>
              <td class="pb-2 font-size-18 text-capitalize">Group</td>
              <td class="pb-2 font-size-18 font-weight-600 text-capitalize">
                <template v-if="supplier.group">{{ supplier.group }}</template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Group</em
                  ></template
                >
              </td>
            </tr> -->
            <tr v-if="false">
              <td class="pb-2 font-size-18 text-capitalize">Phone</td>
              <td class="pb-2 font-size-18 font-weight-600 text-capitalize">
                <template v-if="supplier.phone">{{ supplier.phone }}</template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Phone</em
                  ></template
                >
              </td>
            </tr>
            <!-- <tr>
              <td class="pb-2 font-size-18 text-capitalize">Website</td>
              <td class="pb-2 font-size-18 font-weight-600 text-lowercase">
                <template v-if="supplier.website">{{
                  supplier.website
                }}</template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Website</em
                  ></template
                >
              </td>
            </tr> -->
          </table>
        </div>
      </div>
    </v-col>
    <v-col class="pt-0 gray-background overflow-x" md="4" sm="12" v-if="false">
      <h5 class="font-weight-500 font-size-18 pt-3">
        <v-skeleton-loader
          class="custom-skeleton"
          v-if="pageLoading"
          type="button"
        >
        </v-skeleton-loader>
        <span v-else class="color-custom-blue font-weight-600"
          >Contact Details</span
        >
      </h5>
      <v-skeleton-loader
        class="custom-skeleton"
        v-if="pageLoading"
        type="text@4"
      >
      </v-skeleton-loader>
      <template v-else>
        <table class="width-100">
          <tr v-for="(detail, index) in supplier.details" :key="index">
            <td class="pb-2 font-size-18 text-capitalize">
              {{ getDetailType(detail.type) }}
            </td>
            <td
              class="pb-2 font-size-18 font-weight-600 text-lowercase width-50px"
            >
              ({{ detail.title }})
            </td>
            <td class="pb-2 pl-2 font-size-18 font-weight-600 text-lowercase">
              {{ detail.value }}
            </td>
          </tr>
          <template v-if="false">
            <tr>
              <td class="pb-2 font-size-18 text-capitalize">Unit No.</td>
              <td
                class="pb-2 font-size-18 font-weight-600 text-capitalize"
                colspan="2"
              >
                <template v-if="supplier.unit_number">{{
                  supplier.unit_number
                }}</template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Unit No.</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td class="pb-2 font-size-18 text-capitalize">Address Line 1</td>
              <td
                class="pb-2 font-size-18 font-weight-600 text-capitalize"
                colspan="2"
              >
                <template v-if="supplier.address_line_1">{{
                  supplier.address_line_1
                }}</template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Address Line 1</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td class="pb-2 font-size-18 text-capitalize">Address Line 2</td>
              <td
                class="pb-2 font-size-18 font-weight-600 text-capitalize"
                colspan="2"
              >
                <template v-if="supplier.address_line_2">{{
                  supplier.address_line_2
                }}</template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Address Line 2</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td class="pb-2 font-size-18 text-capitalize">Postal Code</td>
              <td
                class="pb-2 font-size-18 font-weight-600 text-capitalize"
                colspan="2"
              >
                <template v-if="supplier.postal_code">{{
                  supplier.postal_code
                }}</template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Postal Code</em
                  ></template
                >
              </td>
            </tr>
          </template>
        </table>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import Status from "@/view/pages/partials/Status.vue";
import Barcode from "@/view/pages/partials/Barcode.vue";

export default {
  name: "contact-details",
  title: "Supplier",
  mixins: [CommonMixin],
  props: {
    supplier: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getDetailType(param) {
      if (param === 1) {
        return "Email";
      }
      return "Phone";
    },
  },
  components: {
    Status,
    Barcode,
  },
  computed: {
    supplierActivated() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.supplier) === false) {
        return _this.supplier.activated;
      }
      return false;
    },
    fullname() {
      let name = "";
      const _this = this;
      if (
        _this.supplier &&
        _this.lodash.isEmpty(_this.supplier.persons) === false
      ) {
        for (let i = 0; i < _this.supplier.persons.length; i++) {
          if (_this.supplier.persons[i].default) {
            name =
              _this.lodash.startCase(_this.supplier.persons[i].title) +
              ". " +
              _this.supplier.persons[i].first_name +
              " " +
              _this.supplier.persons[i].last_name;
          }
        }
      }
      return name;
    },
    primaryEmail() {
      let email = "";
      const _this = this;
      if (
        _this.supplier &&
        _this.lodash.isEmpty(_this.supplier.details) === false
      ) {
        for (let i = 0; i < _this.supplier.details.length; i++) {
          if (_this.supplier.details[i].type === 1) {
            email = _this.supplier.details[i].value;
            break;
          }
        }
      }
      return email;
    },
    primaryPhone() {
      let phone = "";
      const _this = this;
      if (
        _this.supplier &&
        _this.lodash.isEmpty(_this.supplier.details) === false
      ) {
        for (let i = 0; i < _this.supplier.details.length; i++) {
          if (_this.supplier.details[i].type === 2) {
            phone = _this.supplier.details[i].value;
            break;
          }
        }
      }
      return phone;
    },
    getProfileImage() {
      if (!this.supplier.profile_logo) {
        return null;
      }
      return this.supplier.profile_logo.file.url;
    },
    getBarcode() {
      if (!this.supplier.barcode) {
        return "";
      }
      return this.supplier.barcode;
    },
  },
};
</script>
